'use client';

import dynamic from 'next/dynamic';
import type { ComponentType, ReactNode } from 'react';

import { EmptyComponent } from '../components/EmptyComponent';

// Only include the localhost redirect code when running locally
let DevOnlyRedirect: ComponentType = EmptyComponent;
if (process.env.NODE_ENV === 'development') {
	DevOnlyRedirect = dynamic(async () => import('./LocalHostRedirectDev'), {
		ssr: false,
	});
}

export function LocalHostRedirect(): ReactNode {
	return <DevOnlyRedirect />;
}
